import { Alert, Text } from '@ksyos/design-system';
import { useState } from 'react';
import type { RecorderType } from '@common/enums/recorderType';
import { CustomControlCode } from '@common/enums';
import { ProcessContext } from '@frontend/components/pages/episodeCategory/carePath/process/processContext';
import { useDefinedContext } from '@frontend/utils/hooks/useDefinedContext';
import { HolterInstructionModal } from './HolterInstructionModal';

export function HolterConfigureSuccessAlert(
    props: Readonly<{
        holterDiaryUrl: string;
        recorderType: RecorderType;
    }>
): JSX.Element {
    const { holterDiaryUrl, recorderType } = props;
    const { process } = useDefinedContext(ProcessContext);
    const [isHolterInstructionModalOpen, setIsHolterInstructionModalOpen] = useState<boolean>(false);

    const showInstructions = process.activities.some((activity) =>
        [CustomControlCode.HolterExternalExaminationRequest, CustomControlCode.HolterDirectExaminationRequest].includes(
            activity.serviceActivity.customControlCode
        )
    );

    return (
        <>
            <Alert appearance="success">
                <Text
                    fontWeight="bold"
                    sx={{ color: 'inherit' }}
                >
                    {showInstructions ? (
                        <>
                            De recorder is ingesteld. Je kunt deze meegeven aan je patiënt.&nbsp;
                            <Alert.Link
                                onClick={() => setIsHolterInstructionModalOpen(true)}
                                variant="button"
                            >
                                Lees de plakinstructies.
                            </Alert.Link>
                        </>
                    ) : (
                        <>De recorder is ingesteld. Je kunt deze verzenden naar de patiënt.</>
                    )}
                </Text>
            </Alert>

            {isHolterInstructionModalOpen && (
                <HolterInstructionModal
                    holterDiaryUrl={holterDiaryUrl}
                    onClose={async () => setIsHolterInstructionModalOpen(false)}
                    recorderType={recorderType}
                />
            )}
        </>
    );
}
